const galupload = document.querySelector("#gallery-upload");
const previewgal = document.querySelector(".gallery-imgs");

const createbtn = document.querySelector(".create-entry");
const copycode = document.querySelector(".copy-entries");
const template = document.querySelector(".template-entry");

const output = document.querySelector(".vendor-output");
const codebg = document.querySelector(".clipboard-bg");
const codefield = codebg.querySelector(".clipboard-field");

let savedHTML = localStorage.getItem("vendorHTML");
if (savedHTML) output.innerHTML = savedHTML;

const select = document.querySelector("#select-category");

const vendorPreview = output.querySelector(".vendor-grid");
const vendorPopup = output.querySelector(".vendor-popup");

let previews = vendorPreview.querySelectorAll(".ve");
let popups = vendorPopup.querySelectorAll(".pe");

if (previews.length === 0)
  document.querySelector(".no-category").classList.add("show");

let previewCloseBtns = vendorPreview.querySelectorAll(".ve .close-btn");
let popupCloseBtns = vendorPopup.querySelectorAll(".pe .close-btn");

let curpopup = undefined;

let imgid = 0;
let unprocessedImgs = [];
let processedImgs = [];

for (let btn of [...previewCloseBtns]) {
  btn.addEventListener("click", removePreviewEntry);
}

function templateClick(e) {
  if (e.target !== createbtn) return false;

  let name = this.querySelector("#vendor-name");
  let categories = this.querySelectorAll("#vendor-category");
  let gallery = this.querySelector("#gallery-imgs");
  let bio = this.querySelector("#vendor-bio");
  let instagram = this.querySelector("#vendor-instagram");
  let website = this.querySelector("#vendor-website");

  const imgs = gallery.querySelectorAll("img");

  for (let el of [name, bio, instagram, website]) {
    if (!el.value) {
      alert(
        `You need to provide the ${el.name
          .split("-")
          .map((el) => el.charAt(0).toUpperCase() + el.slice(1))
          .join(" ")}`
      );
      return false;
    }
  }

  const validWebsite = new RegExp("^(http|https)://");
  if (!validWebsite.test(website.value)) {
    alert("Invalid website url, doesn't start with 'http://' or 'https://'");
    return false;
  }

  if (categories[0].value === "none") {
    alert("You need to select a category!");
    return false;
  }

  if ([...imgs].length < 1) {
    alert("You need to upload at least one image!");
    return false;
  }

  const getValidUrl = (url = "") => {
    let newUrl = window.decodeURIComponent(url);
    newUrl = newUrl.trim().replace(/\s/g, "");

    if (/^(:\/\/)/.test(newUrl)) {
      return `http${newUrl}`;
    }
    if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
      return `http://${newUrl}`;
    }

    return newUrl;
  };

  function createPreview(images) {
    const entry = document.createElement("div");
    entry.className = "ve";
    entry.dataset.categories = Array.from(categories)
      .filter((el) => el.value !== "none")
      .map((el) => el.value)
      .join(",");

    const closeBtn = document.createElement("a");
    closeBtn.className = "close-btn";
    closeBtn.href = "javascript:void(0)";

    closeBtn.addEventListener("click", removePreviewEntry);

    const vendorCoverImg = document.createElement("img");
    vendorCoverImg.className = "vci";
    vendorCoverImg.src = images[0];

    const vendorName = document.createElement("h2");
    vendorName.className = "vn";
    vendorName.textContent = name.value;

    const vendorLinks = document.createElement("div");
    vendorLinks.className = "vl";

    const vendorInstagram = document.createElement("a");
    vendorInstagram.className = "vb i";
    vendorInstagram.target = "_blank";
    vendorInstagram.href = `https://instagram.com/${instagram.value}/`;

    const vendorWebsite = document.createElement("a");
    vendorWebsite.className = "vb site";
    vendorWebsite.target = "_blank";
    vendorWebsite.href = website.value;

    vendorLinks.appendChild(vendorInstagram);
    vendorLinks.appendChild(vendorWebsite);

    entry.appendChild(closeBtn);
    entry.appendChild(vendorCoverImg);
    entry.appendChild(vendorName);
    entry.appendChild(vendorLinks);

    entry.addEventListener("click", vendorClick);

    vendorPreview.appendChild(entry);

    previews = vendorPreview.querySelectorAll(".ve");

    createPopup(images);
  }

  function createPopup(images) {
    const entry = document.createElement("div");
    entry.className = "pe";
    entry.dataset.categories = Array.from(categories)
      .filter((el) => el.value !== "none")
      .map((el) => el.value)
      .join(",");

    const closeBtn = document.createElement("a");
    closeBtn.className = "close-btn";
    closeBtn.href = "javascript:void(0)";

    const popupName = document.createElement("h2");
    popupName.className = "pn";
    popupName.textContent = name.value;

    const popupCategory = document.createElement("h2");
    popupCategory.className = "pc";
    // popupCategory.textContent = `${categories[0][categories[0].selectedIndex].textContent} ${(categories[1].value !== 'none') ? '\n' + categories[1][categories[1].selectedIndex].textContent : ''}`;
    popupCategory.textContent = Array.from(categories)
      .map((el) => el.options[el.selectedIndex].text)
      .join(" — ");

    const popupGallery = document.createElement("div");
    popupGallery.className = "pgal";

    const galleryControls = document.createElement("div");
    galleryControls.className = "gctrl";

    for (let img of images) {
      let galleryImage = document.createElement("img");
      galleryImage.src = img;

      galleryControls.appendChild(galleryImage);
    }

    galleryControls.querySelectorAll("img")[0].classList.add("active");

    const prevBtn = document.createElement("a");
    prevBtn.className = "prev-btn";
    prevBtn.href = "javascript:void(0)";
    prevBtn.innerHTML = "&lt;";

    const nextBtn = document.createElement("a");
    nextBtn.className = "next-btn";
    nextBtn.href = "javascript:void(0)";
    nextBtn.innerHTML = "&gt;";

    galleryControls.appendChild(prevBtn);
    galleryControls.appendChild(nextBtn);

    const galleryImgCnt = document.createElement("div");
    galleryImgCnt.className = "gimgcnt";
    galleryImgCnt.innerHTML = "<h4><span></span><span></span></h4>";

    const spans = galleryImgCnt.querySelectorAll("span");
    spans[0].textContent = 1;
    spans[1].textContent = " / " + imgs.length;

    popupGallery.appendChild(galleryControls);
    popupGallery.appendChild(galleryImgCnt);

    popupGallery.addEventListener("click", galleryClick);

    const popupBio = document.createElement("h4");
    popupBio.className = "bio";
    popupBio.textContent = bio.value;

    const popupLinks = document.createElement("div");
    popupLinks.className = "pl";

    const popupInstagram = document.createElement("a");
    popupInstagram.className = "pb i";
    popupInstagram.target = "_blank";
    popupInstagram.href = `https://instagram.com/${instagram.value}/`;

    const popupWebsite = document.createElement("a");
    popupWebsite.className = "pb site";
    popupWebsite.target = "_blank";
    popupWebsite.href = website.value;

    popupLinks.appendChild(popupInstagram);
    popupLinks.appendChild(popupWebsite);

    entry.appendChild(closeBtn);
    entry.appendChild(popupName);
    entry.appendChild(popupCategory);
    entry.appendChild(popupGallery);
    entry.appendChild(popupBio);
    entry.appendChild(popupLinks);

    vendorPopup.appendChild(entry);

    popups = vendorPopup.querySelectorAll(".pe");

    done();
  }

  function done() {
    // Sort previews and popups alphabetically based on vendor name
    const sortedPreviews = Array.from(previews).sort((a, b) => {
      const nameA = a.querySelector(".vn").textContent.toUpperCase();
      const nameB = b.querySelector(".vn").textContent.toUpperCase();
      return nameA.localeCompare(nameB);
    });

    const sortedPopups = Array.from(popups).sort((a, b) => {
      const nameA = a.querySelector(".pn").textContent.toUpperCase();
      const nameB = b.querySelector(".pn").textContent.toUpperCase();
      return nameA.localeCompare(nameB);
    });
    vendorPreview.innerHTML = "";
    vendorPopup.innerHTML = "";
    sortedPreviews.forEach((el) => vendorPreview.appendChild(el));
    sortedPopups.forEach((el) => vendorPopup.appendChild(el));

    name.value = "";
    // categories[0].selectedIndex = 0;
    // categories[1].selectedIndex = 0;
    gallery.innerHTML = "";
    bio.value = "";
    instagram.value = "";
    website.value = "";

    const cats = Array.from(
      document.querySelectorAll(".categories .category-row")
    ).map((el) => {
      const parent = el.parentElement;
      if (parent) parent.removeChild(el);
    });

    localStorage.setItem("vendorHTML", sanitizeHTML(output).innerHTML);

    document.querySelector(".no-category").classList.remove("show");

    imgid = 0;
  }

  uploadImage(unprocessedImgs, createPreview);
}

template.addEventListener("click", templateClick);

function uploadImage(files, cb, urls) {
  if (files.length === 0) return processImage(urls, cb);
  urls = urls || [];
  const cloudName = "crafty-wonderland";
  const preset = "ml_default";

  const url = "https://api.cloudinary.com/v1_1/" + cloudName + "/upload";

  let data = new FormData();
  data.append("upload_preset", preset);
  data.append("file", files[0]);

  var xhr = new XMLHttpRequest();
  xhr.open("POST", url, true);
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

  xhr.onreadystatechange = function (e) {
    if (xhr.readyState == 4 && xhr.status == 200) {
      var response = JSON.parse(xhr.responseText);
      var url = response.secure_url;
      urls.push(url);

      files.shift();

      return uploadImage(files, cb, urls);
    }
  };
  xhr.send(data);
}

function processImage(urls, cb) {
  if (urls.length === 0) return cb(processedImgs);

  let url = urls[0];

  const link = document.createElement("a");
  link.href = url;

  let path = link.pathname.split("/");

  let temp =
    "https://res.cloudinary.com/crafty-wonderland/image/upload/w_500,ar_1:1,c_fill,g_auto/";

  let finalurl = temp + path[path.length - 1];
  processedImgs.push(finalurl);

  urls.shift();
  return processImage(urls, cb);
}

function addToPreviewGallery() {
  const files = galupload.files;

  Object.keys(files).forEach(function (i) {
    const file = files[i];
    const reader = new FileReader();
    reader.onload = function (e) {
      const previewlink = document.createElement("a");
      const preview = document.createElement("img");

      preview.src = e.target.result;
      preview.dataset.id = imgid;

      file.id = imgid;
      imgid += 1;

      unprocessedImgs.push(file);

      previewlink.className = "remove-image";
      previewlink.href = "javascript:void(0)";
      previewlink.appendChild(preview);

      previewlink.addEventListener("click", removeImage);

      previewgal.appendChild(previewlink);

      galupload.value = "";
    };
    reader.readAsDataURL(file);
  });
}

galupload.addEventListener("change", addToPreviewGallery);

function removeImage() {
  const img = this.children[0];
  const id = parseInt(img.dataset.id);

  const index = unprocessedImgs
    .map(function (e) {
      return e.id;
    })
    .indexOf(id);

  if (index > -1) {
    unprocessedImgs.splice(index, 1);
  }

  this.removeEventListener("click", removeImage);
  this.parentElement.removeChild(this);
}

let textareas = document.querySelectorAll("textarea");

autosize(textareas);

let galleries = document.querySelectorAll(".vendor-output .pgal");

function galleryClick(e) {
  const gal = this;
  const galLen = gal.querySelectorAll("img").length - 1;
  const btn = e.target;

  let imgs = gal.querySelectorAll("img");

  let curimg = gal.querySelectorAll(".active")[0];

  if (btn.className === "next-btn") {
    const nextimg =
      curimg.nextElementSibling === null ||
      curimg.nextElementSibling.tagName !== "IMG"
        ? gal.getElementsByTagName("img")[0]
        : curimg.nextElementSibling;
    curimg.classList.remove("active");
    nextimg.classList.add("active");
    curimg = nextimg;
  } else if (btn.className === "prev-btn") {
    const previmg =
      curimg.previousElementSibling === null ||
      curimg.previousElementSibling.tagName !== "IMG"
        ? gal.getElementsByTagName("img")[galLen]
        : curimg.previousElementSibling;
    curimg.classList.remove("active");
    previmg.classList.add("active");
    curimg = previmg;
  }

  const galImgCount = gal.parentElement
    .querySelector(".gimgcnt")
    .querySelectorAll("span");
  let curcount = galImgCount[0];
  let totalcount = galImgCount[1];

  for (let i = 0; i < imgs.length; i++) {
    if (imgs[i] === curimg) curcount.textContent = i + 1;
  }
}

function gallerySetup(gal) {
  const galLen = gal.querySelectorAll("img").length;
  const galImgCount = gal.querySelector(".gimgcnt").querySelectorAll("span");
  galImgCount[0].textContent = 1;
  galImgCount[1].textContent = " / " + galLen;
}

for (let gal of galleries) {
  gal.addEventListener("click", galleryClick);
  if (gal.querySelectorAll("active").length === 0)
    gal.querySelectorAll("img")[0].classList.add("active");
  gallerySetup(gal);
}

function vendorClick(e) {
  if (vendorPopup.classList.contains("open") || e.target.tagName === "A")
    return false;
  let popup = popups[[...previews].indexOf(this)];
  curpopup = popup;

  vendorPopup.classList.add("open");
  popup.classList.add("active");
}

for (let entry of [...previews]) {
  entry.addEventListener("click", vendorClick);
}

function vendorPopupClick(e) {
  if (
    e.target.className !== "vendor-popup open" &&
    e.target.className !== "close-btn"
  )
    return false;

  curpopup.querySelector(".bio").scrollTop = 0;

  let gal = curpopup.querySelector(".pgal");

  gal.querySelector(".active").classList.remove("active");
  gal.querySelectorAll("img")[0].classList.add("active");

  const galLen = gal.querySelectorAll("img").length;
  const galImgCount = gal.querySelector(".gimgcnt").querySelectorAll("span");
  galImgCount[0].textContent = 1;
  galImgCount[1].textContent = " / " + galLen;

  curpopup.classList.remove("active");
  vendorPopup.classList.remove("open");
}

vendorPopup.addEventListener("click", vendorPopupClick);

function removePreviewEntry() {
  let yes = confirm("Do you want to delete this entry?");
  if (!yes) return false;

  const preview = this.parentElement;
  const popup = popups[[...previews].indexOf(this.parentElement)];

  popup.parentElement.removeChild(popup);

  preview.removeEventListener("click", vendorClick);
  preview.parentElement.removeChild(preview);

  previews = vendorPreview.querySelectorAll(".ve");
  popups = vendorPopup.querySelectorAll(".pe");

  previewCloseBtns = vendorPreview.querySelectorAll(".ve .close-btn");
  popupCloseBtns = vendorPopup.querySelectorAll(".pe .close-btn");

  if (previews.length === 0)
    document.querySelector(".no-category").classList.add("show");

  localStorage.setItem("vendorHTML", sanitizeHTML(output).innerHTML);
}

function sanitizeHTML(html) {
  let clone = html.cloneNode(true);

  let closeBtns = clone.querySelectorAll(".ve a.close-btn");
  closeBtns.forEach((btn) => btn.remove());

  return clone;
}

function selectChange() {
  document.querySelector(".no-category").classList.remove("show");
  if (previews.length === 0) {
    document.querySelector(".no-category").classList.add("show");
    return false;
  }
  if (select.value === "none") {
    for (let el of previews) {
      el.classList.remove("hidden");
    }
  } else {
    for (let el of previews) {
      el.classList.remove("hidden");
      if (el.dataset.categories.split(",").includes(select.value)) continue;
      el.classList.add("hidden");
    }
    let truth = [...document.querySelectorAll(".ve")].every(function (e) {
      return e.classList.contains("hidden");
    });
    if (truth) document.querySelector(".no-category").classList.add("show");
  }
}

select.addEventListener("change", selectChange);

function copyCode() {
  // let text = '<div style="position: relative;">' +
  //   '<div style="text-align: center;">' +
  //   `<select name="select-category" id="select-category">
  //                     <option value="none">View All</option>
  //                     <option value="accessories">Accessories</option>
  //                     <option value="art-prints">Art / Prints</option>
  //                     <option value="bath+body">Bath + Body</option>
  //                     <option value="candles">Candles</option>
  //                     <option value="cards-books">Cards / Books</option>
  //                     <option value="ceramic-glass">Ceramics / Glass</option>
  //                     <option value="children">Children's Items</option>
  //                     <option value="clothing-tshirts">Clothing / T-Shirts</option>
  //                     <option value="spirits-wine">Distilled Spirits / Wine</option>
  //                     <option value="food-candy">Food / Candy</option>
  //                     <option value="decor-plants">Home Decor / Plants</option>
  //                     <option value="jewelry">Jewelry</option>
  //                     <option value="kits-patterns">Kits / Patterns</option>
  //                     <option value="knit-crochet">Knit / Crochet Items</option>
  //                     <option value="pets">Pet Items</option>
  //                     <option value="plush">Plush</option>
  //                     <option value="purses-totes">Purses / Totes</option>
  //                     <option value="housewares-furniture">Wood Housewares / Furniture</option>
  //                  </select>`.replace(/(\r\n|\n|\r)/gm, '') +
  //   '</div>' +
  //   output.innerHTML.trim()
  //   '<h3 class="no-category">No vendors found for selected category.</h3>' +
  //   '</div>';

  let selectText = document
    .querySelector("#select-category")
    .parentElement.outerHTML.replace(/[\r\n]+/gm, "")
    .replace(/\s+/g, " ")
    .trim();

  var temp = document.createElement("div");
  temp.innerHTML = output.innerHTML;

  temp.querySelectorAll(".ve .close-btn").forEach((btn) => btn.remove());

  let outputText = temp.innerHTML
    .replace(/[\r\n]+/gm, "")
    .replace(/\s+/g, " ")
    .trim();
  let text = `<div style="position:relative;"> ${selectText} ${outputText} <h3 class="no-category">No vendors found for selected category.</h3> </div>`;

  codefield.innerText = text;
  codebg.classList.add("open");
  codefield.classList.add("active");
}

copycode.addEventListener("click", copyCode);

function closeClipboard(e) {
  if (e.target.className !== "clipboard-bg open") return false;
  codefield.classList.remove("active");
  codebg.classList.remove("open");
}

codebg.addEventListener("click", closeClipboard);

function clearVendors() {
  let first = confirm("Are you sure you want to delete all existing vendors?");
  if (first) {
    let second = confirm(
      "Do you accept that confirming this will remove all vendors?"
    );
    if (second) {
      output.innerHTML = "";
      localStorage.setItem("vendorHTML", "");

      previews = [];
      popups = [];

      document.querySelector(".no-category").classList.add("show");
    }
  }
}

const clearvendors = document.querySelector(".clear-entries");

clearvendors.addEventListener("click", clearVendors);

const addCategoryBtn = document.querySelector("#add-category");
const categoryTemplate = document.querySelector(".category-row-template");
const categoriesDiv = document.querySelector(".categories");

addCategoryBtn.addEventListener("click", function (ev) {
  const clone = categoryTemplate.cloneNode(true);
  clone.className = "category-row";
  clone.querySelector(".vendor-category").id = "vendor-category";
  clone.style.display = "";

  clone
    .querySelector(".category-row-delete")
    .addEventListener("click", function () {
      const parent = this.parentElement;
      const parentParent = parent.parentElement;
      parentParent.removeChild(parent);
    });

  categoriesDiv.appendChild(clone);
});

const getCurrentVendors = document.querySelector(".get-current-entries");

getCurrentVendors.addEventListener("click", function (ev) {
  const req = fetch(
    "https://craftywonderland.com/pages/2025-spring-market-vendor-list"
  )
    .then((res) => res.text())
    .then((data) => {
      if (
        confirm(
          "Are you sure you want to lose your current vendors and get the live vendor entries?"
        ) == true
      ) {
        const parser = new DOMParser();
        const html = parser.parseFromString(data, "text/html");

        const sanitized = sanitizeHTML(html);

        const vendorGrid = sanitized.querySelector(".vendor-grid");
        const vendorPopup = sanitized.querySelector(".vendor-popup");

        vendorGrid.querySelectorAll(".ve").forEach((el) => {
          let closeBtn = document.createElement("a");
          closeBtn.className = "close-btn";
          el.prepend(closeBtn);
        });

        const text = `${vendorGrid.outerHTML
          .replace(/[\r\n]+/gm, "")
          .replace(/\s+/g, " ")
          .trim()} ${vendorPopup.outerHTML
          .replace(/[\r\n]+/gm, "")
          .replace(/\s+/g, " ")
          .trim()}`;
        localStorage.setItem("vendorHTML", text);
        location.reload();
      }
    });
});

document.addEventListener("DOMContentLoaded", function () {
  previews = vendorPreview.querySelectorAll(".ve");

  for (let preview of previews) {
    const closeBtn = document.createElement("a");
    closeBtn.className = "close-btn";
    closeBtn.href = "javascript:void(0)";

    closeBtn.addEventListener("click", removePreviewEntry);

    preview.prepend(closeBtn);
  }
});
